/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, DatePicker, Row, Space, Tooltip } from 'antd'
import { FormProvider, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { DATE_TIME_ICON, REMOVE_ICON } from 'Assets'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAuth, useRoles, useRoot } from 'Hooks'
import _ from 'lodash'
import { FormInput, FormInputNumber, FormSelect } from '../form'
import ModalComponent from '../modal'
import InnerScrollPicker from '../form/FormDatePicker/innerScrollPicker'
import { WrapperLabel } from '../form/FormInput'
import { WrapperLabelSelect } from '../form/FormSelect'
import { inviteMemberResolver } from './resolver'
import { SUCCESS } from '../../Stores'
import { DELETE_MEMBER_PORTFOLIO, POST_INVITE_MEMBER_PORTFOLIO } from '../../Modules/dashboard/store/constants'
import { getLocalStorage } from '../../Utils'
import { useDashboard, useVisibleTutorial } from '../../Hooks'
import SetTheDateTutorial from '../tutorial/SetTheDate'
import AnnualAssetsGoalsTutorial from '../tutorial/AnnualAssetsGoalsTutorial'
import SeeMemberTutorial from '../tutorial/SeeMemberTutorial'
import Loading from '../loading'
import { ROLE_TYPE } from '../../Constants/permission'

const ProjectIPOStyled = styled.div`
  flex: 0.5;
  margin-left: 20px !important;

  p,
  button {
    display: inline-block;
    vertical-align: middle;
  }

  p {
    margin-right: 20px;
  }
`

const SetDateButtonStyled = styled(Button)`
  position: relative;

  &.ant-btn, button {
    max-width: 170px;
    margin-left: 22px;
    width: 100%;
    background: #616161;
    border-color: transparent;
    position: relative;

    &.has-data {
      max-width: fit-content;
    }

    &:hover,
    &:active,
    &:focus,
    &:focus-visible {
      color: ${({ theme }) => theme.white} !important;
      background: #616161 !important;
      border-color: transparent;
      outline: transparent;
    }
  }

  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    margin-right: 0;
    display: inline-block;
    width: 100%;
    text-align: left;

    color: ${({ theme }) => theme.white};
  }

  svg {
    position: absolute;
    right: 11px;
  }

  svg,
  span {
    display: inline-block;
    vertical-align: middle;
  }
`

const TimeToIPOWrapperStyled = styled.div`
  text-align: right;
  flex: 1;

  & > span {
    display: inline-block;
    margin: 0 13px;
  }

  form {
    display: inline-block;
    width: 100%;

    .input-number {
      width: 100%;
    }
  }
`

const FormInputNumberTimeToIPO = styled.div`
  background: ${({ theme }) => theme.text_secondary};
  border: 1px solid ${({ theme }) => theme.border};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.white};
  height: 32px;
  display: flex;
  align-items: center;
  min-width: 120px;
  padding: 0 16px;
  justify-content: center;
`

const TitleStyled = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.25px;
  display: inline-block;
  margin-right: 170px !important;
  color: ${({ theme }) => theme.text_primary};
`

const Paragraph = styled.p`
  font-weight: 500;
  font-size: ${({ fontSize }) => fontSize || 12}px;
  line-height: 20px;

  color: ${({ color, theme }) => (color || theme.black)};

  margin: ${({ isMargin }) => isMargin}px;

  @media only screen and (max-width: 1023px) {
    width: ${({ wrapLine }) => wrapLine === true && 100}%;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const TimeToIPOStyled = styled(Row)`
  align-items: center;
  justify-content: flex-end;

  .ant-form-item {
    max-width: 162px;
    width: 100%;
  }

  span {
    margin: 0 16px;
  }

  p,
  button {
    display: inline-block;
    vertical-align: middle;
  }


  form {
    display: inline-block;
  }
`

const PrivateTitleStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 54px;


  & > div:not(${TitleWrapper}):not(${TimeToIPOWrapperStyled}), h1 {
    display: inline-block;
    margin: 0;


    ${ProjectIPOStyled} {
      text-align: center;
    }

    ${TimeToIPOWrapperStyled} {
      flex: 1;
    }
  }

  @media only screen and (max-width: 1024px) {
    display: block;

    ${ProjectIPOStyled},
    ${TimeToIPOWrapperStyled} {
      flex: none;
      display: inline-block;
      vertical-align: middle;
      text-align: left;
      width: 50%;
    }

    ${ProjectIPOStyled} {
      margin: 0 !important;
    }

    ${TimeToIPOStyled} {
      display: inline-flex;
      flex: 1;
      align-items: center;
    }

    ${TimeToIPOWrapperStyled} {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      flex-basis: 50%;

      & > form {
        max-width: inherit;
        width: 100%;
      }
    }

    ${SetDateButtonStyled} {
      max-width: 150px;
      margin-left: 10px;
    }
  }

  .reset-countdown {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3B82F6;
    border: none;
    background: none;
    cursor: pointer;
  }

  @media only screen and (max-width: 996px) {
    display: block;

    ${TitleStyled} {
      margin-left: 0 !important;
    }

    ${ProjectIPOStyled},
    ${TimeToIPOWrapperStyled} {
      flex: none;
      display: block;
      vertical-align: middle;
      text-align: left;
      width: 100%;
    }

    ${TimeToIPOWrapperStyled},
    ${TimeToIPOStyled} {
      width: 100%;
      margin: 16px 0;
    }

    ${TimeToIPOStyled} {
      display: flex;
      justify-content: flex-start;
    }
  }
`

const TimeParseIPO = styled.div`
  display: flex;
  margin-left: 8px;
  max-width: fit-content;
  width: 100%;
  background: #163947;
  color: ${({ theme }) => theme.white};
  height: 32px;
  padding: 4px;

  span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    text-transform: uppercase;
    font-size: 8px;
    line-height: 1;
  }

  .number-date {
    font-size: 12px;
    padding: 4px;
  }

  @media only screen and (max-width: 1023px) {
    max-width: fit-content;
    width: 100%;
  }
`

const MemberManagementModalStyled = styled(ModalComponent)`
  button.ant-btn-primary {
    width: auto !important;
  }
`

export const MemberManagementTableStyled = styled.table`

  thead {
    tr {
      background: #3B82F6;
    }
  }

  th {
    text-align: left;

    font-weight: 700;
  }

  th, td {
    padding: 0 6px;
  }

  tr {
    border: 1px solid #D9D9D9;

    background: #F9F9F9;

    td, th, a {
      font-size: 12px;
      line-height: 20px;

      color: ${({ theme }) => theme.black};
    }
  }

  td {
    text-align: center;

    &:first-child {
      padding-left: 35px;
      text-align: left;
    }

    &.col {
      &.name {
        span {
          width: 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }

      &.role {
        text-transform: capitalize;
        text-align: left;
      }
    }

    a {
      text-decoration: underline;
      display: inline-block;

      width: 90px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .form-wrapper {
    background: #F9F9F9;
    border: 1px solid #D9D9D9;
    padding: 3px 27px;

    input,
    .ant-form-item-control,
    .ant-select-selector {
      background: #F9F9F9 !important;
    }
  }

  ${WrapperLabel},
  ${WrapperLabelSelect} {
    font-weight: 700;
    font-size: 10px;
    line-height: 20px;

    color: ${({ theme }) => theme.black};
  }

  .ant-select-selection-item,
  .ant-input {
    font-size: 12px;
  }

  button {
    border: none;
    background: none;

    cursor: pointer;
  }
`

export const WrapperTutorial = styled.div`
  position: relative;
  display: inline-block;
`

const PrivateTitle = ({
  title,
  subTitle,
  isShowProjectInfo,
  timeToIPO,
  updateTimeIPOAction,
  portFolioById,
  updateTimeIPOStatus,
  getPortFolioByIdAction,
  getAssetGoalsAction,
  getAllMemberInPortfolioAction,
  getGrowthSchedulesAction,
  postInviteMemberPortFolioAction,
  listRoles,
  listMemberInPortfolio,
  deleteMemberPortFolioAction,
  success,
  showModalMessageAction,
  isPortfolioAdmin,
  isCompanyAdmin,
  isEditor,
  isUser,
  ...props

}) => {
  const { id } = useParams()
  const { t } = useTranslation(['common', 'auth'])
  const [date, setDateSubmit] = useState(null)
  const [roles, setRoles] = useState(null)
  const [pickerError, setPickerError] = useState(false)
  const { profile } = useAuth()
  const [visibleModal, setVisibleModal] = useState(false)
  const [visibleModalMember, setVisibleModalMember] = useState(false)
  const [isPopupDeleteConfirm, setPopupDeleteConfirm] = useState(false)
  const [isPopupDeletedConfirm, setPopupDeletedConfirm] = useState(false)
  const [isPopupInviteConfirm, setPopupInviteConfirm] = useState(false)
  const [confirmEmail, setConfirmEmail] = useState(null)
  const { tutorialShow } = useVisibleTutorial()
  useEffect(() => {
    const rolesArray = _.isArray(listRoles) && listRoles?.length > 0 && listRoles?.map((role) => ({
      value: role.code, label: role.description
    }))

    setRoles(rolesArray)
  }, [listRoles])

  const form = useForm({
    defaultValues: {}
  })
  const inviteForm = useForm({
    defaultValues: {}, reValidateMode: 'onChange', mode: 'all', resolver: yupResolver(inviteMemberResolver(t, roles))
  })
  const { handleSubmit } = form
  const { handleSubmit: submitInviteForm, reset: resetInviteField } = inviteForm

  const onSubmit = () => {
    const dateSelected = moment(date).toISOString()
    if (date) {
      updateTimeIPOAction({ id, time: dateSelected })
      setVisibleModal(false)
    }
  }

  const visibleSetDate = () => {
    setVisibleModal(true)
  }

  const resetCountDown = () => {
    setVisibleModal(true)
  }
  const popupInviteConfirm = () => (
    <>
      Invitation mail to <a href={`mailto:${confirmEmail?.email}`}>{confirmEmail?.email} </a>
      as a user has successfully sent.
    </>
  )

  const popupDeleteConfirm = () => (
    <>
      Do you delete user account <a href={`mailto:${confirmEmail?.email}`}>{confirmEmail?.email} </a> ?
    </>
  )

  const popupDeletedConfirm = () => (
    <>
      <a href={`mailto:${confirmEmail?.email}`}>{confirmEmail?.email} </a> has deleted
    </>
  )

  /**
   *
   * @param member
   */
  const removeUserFromPortfolio = (member) => {
    setPopupDeleteConfirm(true)
    setConfirmEmail(member)
  }

  const handleRemoveMemberSubmit = () => {
    deleteMemberPortFolioAction({ id, userId: confirmEmail?.id })
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (success === SUCCESS(DELETE_MEMBER_PORTFOLIO)) {
      setPopupDeleteConfirm(false)
      setPopupDeletedConfirm(true)
    }
    if (success === SUCCESS(POST_INVITE_MEMBER_PORTFOLIO)) {
      resetInviteField()
      setPopupInviteConfirm(true)
    }
  }, [success])
  useEffect(() => {
    if (visibleModalMember) {
      getAllMemberInPortfolioAction({ id })
    }
    if (visibleModalMember === false) {
      resetInviteField()
    }
  }, [visibleModalMember, id])

  function renderModalMemberInvite() {
    const { isLoading } = useDashboard()
    return (
      (isPortfolioAdmin || isCompanyAdmin) && (
        <MemberManagementTableStyled
          width="100%"
          style={{
            marginTop: 28
          }}
        >
          {isLoading && <Loading loadingMini />}
          <thead>
            <tr>
              <th colSpan="4">INVITE MEMBER</th>
            </tr>
          </thead>
          <FormProvider {...inviteForm}>
            <div className="form-wrapper">
              <FormInput name="email" label={t('auth:email')} placeholder={t('auth:emailAddress')} />
              <FormSelect
                t={t}
                name="role"
                label={t('common:Role')}
                options={roles}
              />
            </div>
          </FormProvider>
        </MemberManagementTableStyled>
      )
    )
  }

  const renderModalMemberManagementList = () => {
    const { isLoading } = useDashboard()

    return (
      <>
        {isLoading && <Loading loadingMini />}
        <MemberManagementTableStyled width="100%">
          <thead>
            <tr>
              <th colSpan="4">{t('common:Member')}</th>
            </tr>
          </thead>
          <tbody>

            {listMemberInPortfolio && listMemberInPortfolio.map((member) => (
              <tr>
                <td className="col name">
                  <Tooltip
                    title={member.user_name}
                    style={{
                      padding: 0
                    }}
                  >
                    <span>{member.user_name}</span>
                  </Tooltip>
                </td>
                <td className="col mail">
                  <Tooltip
                    placement="topLeft"
                    title={member.email}
                    style={{
                      padding: 0
                    }}
                  >
                    <a href={`mailto:${member.email}`}>{member.email}</a>
                  </Tooltip>

                </td>
                <td className="col role">{member.role}</td>
                <td className="col action">
                  {(isCompanyAdmin || isPortfolioAdmin) && member.code !== getLocalStorage('ROLE') && (// eslint-disable-next-line jsx-a11y/control-has-associated-label
                  <button type="button" onClick={() => removeUserFromPortfolio(member)}><REMOVE_ICON /></button>)}
                </td>
              </tr>
            ))}
          </tbody>
        </MemberManagementTableStyled>

        {renderModalMemberInvite()}
      </>
    )
  }

  const inviteSubmit = (values) => {
    postInviteMemberPortFolioAction({ id, values })
    setConfirmEmail(values)
  }

  const [dayDiff, setDayDiff] = useState(0)

  function calculateCountDown() {
    return moment(portFolioById?.time_to_ipo).diff(new Date())
  }

  useEffect(() => {
    if (portFolioById?.time_to_ipo && moment(portFolioById?.time_to_ipo).diff(new Date()) > 0) {
      setTimeout(() => {
        setDayDiff(
          calculateCountDown
        )
      }, 1000)
    } else {
      setDayDiff(
        0
      )
    }

    return () => {
      clearTimeout(calculateCountDown)
    }
  }, [dayDiff, portFolioById?.time_to_ipo])

  const duration = moment.duration(dayDiff)

  const pickerOnChange = (value) => {
    if (moment(value).diff(moment(), 'hours') < 0) {
      showModalMessageAction({ message: 'IPO setting time is not valid' })
      setPickerError(true)
    } else {
      setPickerError(false)
    }
  }

  const onOk = (value) => {
    const dateSelected = moment(value).toISOString()
    setDateSubmit(dateSelected)
  }

  return (
    <>
      <PrivateTitleStyled {...props}>
        <TitleWrapper>
          <TitleStyled>{title}</TitleStyled>
        </TitleWrapper>
        {timeToIPO ? (
          <TimeToIPOWrapperStyled>
            <FormProvider {...form}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <TimeToIPOStyled>
                  <Paragraph wrapLine isMargin={0} fontSize={18}>{t('TIME_TO_IPO')}</Paragraph>
                  {portFolioById?.time_to_ipo ? (
                    <TimeParseIPO>
                      <span className="number-date">
                        {duration.years()}
                        <span>years</span>
                      </span>
                      <span className="number-date">
                        {duration.months()}
                        <span>months</span>
                      </span>
                      <span className="number-date">
                        {duration.days()}
                        <span>days</span>
                      </span>
                      <span className="number-date">
                        {duration.hours()}
                        <span>hours</span>
                      </span>
                      <span className="number-date">
                        {duration.minutes()}
                        <span>minutes</span>
                      </span>
                      <span className="number-date">
                        {duration.seconds()}
                        <span>seconds</span>
                      </span>
                    </TimeParseIPO>
                  ) : (
                    // eslint-disable-next-line no-mixed-operators
                    (portFolioById?.role.includes(ROLE_TYPE.COMPANY_ADMIN) || portFolioById?.role.includes(ROLE_TYPE.PORTFOLIO_ADMIN)) && (
                      <>
                        <WrapperTutorial style={{
                          position: 'relative'
                        }}
                        >
                          {
                            profile?.lastLogin === null && tutorialShow === 1
                            && <SetTheDateTutorial />
                          }

                          <SetDateButtonStyled onClick={() => visibleSetDate()}>
                            <span>{t('SET_THE_DATE')}</span>
                            <DATE_TIME_ICON />
                          </SetDateButtonStyled>
                        </WrapperTutorial>
                      </>
                    ))}
                  <span> = </span>

                  <FormInputNumberTimeToIPO>{dayDiff ? Math.round(duration.asHours()) : ''} &nbsp;&nbsp;Hours</FormInputNumberTimeToIPO>
                </TimeToIPOStyled>
              </form>
              {// eslint-disable-next-line no-mixed-operators
                (portFolioById?.role.includes(ROLE_TYPE.COMPANY_ADMIN) || portFolioById?.role.includes(ROLE_TYPE.PORTFOLIO_ADMIN)) && portFolioById?.time_to_ipo
                && <button className="reset-countdown" onClick={resetCountDown}>Reset Countdown</button>
              }
            </FormProvider>
          </TimeToIPOWrapperStyled>
        ) : null}
      </PrivateTitleStyled>
      <Paragraph fontSize={14} isMargin={0} color="#616161">{subTitle}</Paragraph>
      <ModalComponent
        title="COUNTDOWN SETTING"
        themeMode="dark"
        onCancel={() => setVisibleModal(false)}
        visible={visibleModal}
        disabledSubmit={!!pickerError}
        onSubmit={() => onSubmit()}
        onSubmitText={t('common:save')}
      >
        Select your IPO date
        {/* <InnerScrollPicker setDateSubmit={setDateSubmit} /> */}
        <DatePicker
          showTime
          onOk={onOk}
          onChange={pickerOnChange}
          minuteStep={5}
          secondStep={5}
          showNow={false}
        />
      </ModalComponent>

      <MemberManagementModalStyled
        modalWith={412}
        title={isCompanyAdmin || isPortfolioAdmin ? 'MEMBER MANAGEMENT' : 'MEMBER LIST'}
        onCancel={() => setVisibleModalMember(false)}
        cancel={false}
        visible={visibleModalMember}
        onSubmit={submitInviteForm(inviteSubmit)}
        onSubmitText="Send Invitation"
        isNotFooterButton={isUser || isEditor}
      >
        <>
          {renderModalMemberManagementList()}
        </>
      </MemberManagementModalStyled>

      <MemberManagementModalStyled
        title="Delete account"
        onCancel={() => setPopupDeleteConfirm(false)}
        cancel
        visible={isPopupDeleteConfirm}
        onSubmit={handleRemoveMemberSubmit}
        onSubmitText={t('common:delete')}
        showCloseButton={false}
      >
        {popupDeleteConfirm()}
      </MemberManagementModalStyled>

      <MemberManagementModalStyled
        title="Delete account"
        cancel={false}
        visible={isPopupDeletedConfirm}
        onSubmit={() => setPopupDeletedConfirm(false)}
        showCloseButton={false}
      >
        {popupDeletedConfirm()}

      </MemberManagementModalStyled>

      <MemberManagementModalStyled
        title="Invitation has sent"
        onCancel={() => setPopupInviteConfirm(false)}
        visible={isPopupInviteConfirm}
        onSubmit={() => setPopupInviteConfirm(false)}
        cancel={false}
        showCloseButton={false}
      >
        {popupInviteConfirm()}
      </MemberManagementModalStyled>
    </>
  )
}

PrivateTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  isShowProjectInfo: PropTypes.bool,
  timeToIPO: PropTypes.bool,
  listRoles: PropTypes.any,
  portFolioById: PropTypes.object,
  updateTimeIPOAction: PropTypes.func,
  getPortFolioByIdAction: PropTypes.func,
  updateTimeIPOStatus: PropTypes.bool,
  getAssetGoalsAction: PropTypes.func,
  getGrowthSchedulesAction: PropTypes.func,
  postInviteMemberPortFolioAction: PropTypes.func,
  getAllMemberInPortfolioAction: PropTypes.func,
  deleteMemberPortFolioAction: PropTypes.func,
  listMemberInPortfolio: PropTypes.array,
  success: PropTypes.any,
  showModalMessageAction: PropTypes.func,
  isCompanyAdmin: PropTypes.bool,
  isPortfolioAdmin: PropTypes.bool,
  isUser: PropTypes.bool,
  isEditor: PropTypes.bool
}

export default React.memo(PrivateTitle)
